import JobViewContainer from "./JobViewContainer";

export default JobViewContainer;